import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginForm, ResetPasswordForm } from '../../../models/user';

import { TranslateService } from '@ngx-translate/core';

import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WebUtils } from '../../utils/web.utils';
import { AppSettings } from '../../utils/app-settings';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit, OnDestroy {
  reset: FormGroup;
  errorMessage: string;
  successMessage: string;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService) {}

  ngOnInit() {
    WebUtils.loadHubspotChatWidget();

    this.reset = new FormGroup({
      email: new FormControl(this.auth.resetPasswordEmail, [
          Validators.required,
          Validators.email
        ]),
      });
  }

  ngOnDestroy(): void {
    WebUtils.removeHubspotChatWidget();
  }

  onSubmit({ value, valid }: {value: ResetPasswordForm, valid: boolean}) {
    this.auth.updateResetPassEmail(undefined);
    this.errorMessage = '';
    this.successMessage = '';

    if (valid) {
      this.auth.forgotPassword(value.email, (msg) => {
        this.successMessage = this.translate.instant('forgot_password.success_msg');
      }, (err) => {
        if (err.error.data === 'invalid_credential') {
          this.errorMessage = this.translate.instant('forgot_password.not_verified');
        } else if (err.error.data === 'sso_user_not_allowed') {
          this.errorMessage = this.translate.instant('LOGIN.sso_user', { mmiLoginLink: AppSettings.mmiLoginLink() });
        } else {
          this.errorMessage = this.translate.instant('forgot_password.error_msg');
        }
      });
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/reset/reset.component.ts